import { OFFER_TYPE } from './constants';
import { offerTypes } from './helpers';

export const promotionOfferDefaults = {
  is_active: 1,
  offer_type: OFFER_TYPE.PERCENT,
  discount_value: 0,
  type_value: 1,
  shipping_promotion: 1,
  business_list: [],
  list_offer_gifts: [],
};

export const buildPromotionOfferPayload = (values) => {
  const offerType = Number(values.offer_type);
  if (!offerTypes.some(({ value }) => value === offerType)) throw new Error('Vui lòng chọn loại ưu đãi.');
  return {
    ...values,
    offer_type: offerType,
    ...Object.fromEntries(offerTypes.map(({ value, field }) => [field, Number(value === offerType)])),
    business_list: (values.business_list || []).map((item) => item?.id ?? item?.value ?? item),
  };
};
